module.exports = __webpack_public_path__ + "static/media/codeSwitching.feb40eca.gif";